const onClick = ($el: HTMLElement, dom: { $content: HTMLElement | null; $toggleBtn: HTMLElement | null }) => {
  $el.classList.toggle("active");

  if (dom.$content && !dom.$content.dataset.disableContentAnimation) {
    dom.$content.style.maxHeight = dom.$content.style.maxHeight
      ? ""
      : `${dom.$content.scrollHeight}px`;
  }
  else if (dom.$content) {
    dom.$content.style.maxHeight = dom.$content.style.maxHeight ? "" : "none";
  }
};
declare global {
  interface Window {
    listenerEnabled: { root: Document | ShadowRoot; enabled: boolean }[];
  }
}
const instance = ($el: HTMLElement) => {
  const dom = {
    $content: $el.querySelector<HTMLElement>(".js-accordion-item-content"),
    $toggleBtn: $el.querySelector<HTMLElement>(".js-accordion-toggle-btn"),
  };

  dom.$toggleBtn?.removeEventListener("click", () => onClick($el, dom));
  dom.$toggleBtn?.addEventListener("click", () => onClick($el, dom));
};
window.listenerEnabled = [];
export default (root: Document | ShadowRoot = document) => {
  if (window.listenerEnabled.some(x => x.root === root && x.enabled)) return;

  const $accordionItems
    = root.querySelectorAll<HTMLElement>(".js-accordion-item");

  if ($accordionItems.length === 0) return;

  window.listenerEnabled.push({ root, enabled: true });
  $accordionItems.forEach(($element) => {
    instance($element);
  });
};
